import { helpers } from "vuelidate/lib/validators";

export const isOneOf = (options, optionsLabels = null) =>
    helpers.withParams(
        { type: "isOneOf", options, optionsLabels },
        (value) => !helpers.req(value) || options.includes(value)
    );
